import React from 'react';
import { clsx } from 'clsx';

export const GlassPanel = ({ children, className, blur = 'md' }) => {
  const blurs = {
    sm: 'glass-panel--blur-sm',
    md: 'glass-panel--blur-md',
    lg: 'glass-panel--blur-lg',
  };

  return (
    <div className={clsx('glass-panel', blurs[blur], className)}>
      {children}
    </div>
  );
};

export default GlassPanel;
